<template>
  <Page back :label="$route.name" withMargin>
    <div class="flex flex-wrap gap-4">
      <ProductsCategoryItem
        :key="i"
        class="w-1/2-gap-8"
        v-for="(segment, i) in segments"
        :product="segment"
        :onClick="() => routeToSegment(segment)"
      />
    </div>
    <separator v-if="catalogues?.length" />
    <div v-if="catalogues?.length">
      <document-list-item
        v-for="(item, i) in catalogues"
        :key="i"
        :document="item"
      />
    </div>
  </Page>
</template>

<script>
import Page from "../../components/Page.vue";
import Separator from "../../components/Separator.vue";

import urls from "@/urls";
import messages from "@/messages";
import DocumentListItem from "../../components/DocumentListItem.vue";
import ProductsCategoryItem from "./ProductsCategoryItem.vue";

export default {
  components: {
    Page,
    Separator,
    DocumentListItem,
    ProductsCategoryItem,
  },
  data() {
    return {
      segments: [],
      catalogues: [],
    };
  },
  computed: {},
  created() {
    this.getProducts();
  },
  methods: {
    routeToSegment(segment) {
      const link = `/products/${segment.id}`;
      this.$router.push(link);
    },
    async getProducts() {
      try {
        const prod = await this.$http({
          method: "GET",
          url: urls.products.segments,
          params: {},
        });
        if (prod) {
          if (prod.categories) {
            this.segments = prod.categories;
          }
          if (prod.catalogues?.length) {
            this.catalogues = prod.catalogues;
          }
        }

        console.log("Products catalogues", prod.catalogues);
      } catch (e) {
        console.error(e);
        this.$toast({
          message: messages.errors.segments,
          color: "danger",
        });
      }
    },
  },
};
</script>
